import { useMutation, useQuery } from 'react-query';
import { extractErrorMessage } from '../../helpers';
import { getSetting, setSetting, updateRecaptchaSettings } from '../../services/BackendService';
import toast from 'react-hot-toast';

export const useGetSetting = (key: string, queryKey: string, options?: any) => {
  return useQuery([queryKey], () => getSetting(key), options);
};

export const useSetSetting = () => {
  return useMutation(({ key, value }: { key: string; value: string | boolean | null }) => setSetting(key, value), {
    onError: (error) => {
      toast.error(extractErrorMessage(error));
    },
  });
};

interface IRecaptchaParams {
  siteKey: string;
  secret: string;
  score: string;
  url: string;
}

export const useSetRecatpchaV3 = () => {
  return useMutation(({ siteKey, secret, score, url }: IRecaptchaParams) =>
    updateRecaptchaSettings(siteKey, secret, score, url)
  );
};
